// extracted by mini-css-extract-plugin
export default {"dataFilters":"DataFilters_dataFilters__cAVDp"};